const styles = theme => ({
  addButton: {
    borderRadius: '25px',
    padding: '5px 20px',
    border: '1px solid #ccc',
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    backgroundColor: '#fff',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontFamily: theme.typography.fontFamily,
  },
  centerProgress: {
    textAlign: 'center'
  },
  btnListTextApostille:{
    color:'#fff',
    padding: '16px 22px'
  },
  copyButton: {
    borderRadius: '25px',
    padding: '5px 20px',
  },
});

export default styles;
